// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opt-out-reason[data-v-8c4610ba]{font-size:.875rem;color:#fff;margin-right:.5rem!important}", ""]);
// Exports
module.exports = exports;
